module.exports = __webpack_public_path__ + "img/fission-func2.4dcd438c.jpg";